import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Topbar from './components/Topbar';
import Navbar from './components/Navbar';
import ContactPage from './pages/ContactPage';
import Footer from './components/Footer';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';

const App = () => {
  return (
    <Router>
      <Topbar />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/produtos" element={<ProductsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
